/* lua.js generated code 0.3.0 */

function getRealArgsByIndex(args, index) {
    // lua中参数多一个
    index--
    if (args[index] && type(args[index]) === "string") {
        args[index] = getRealResourceName(args[index])
    }
    return args
}

cc.loader.autoLoad = function (resources, option, loadCallback) {
    console.log('cc.loader.autoLoad is deprecated, use RES.load instead')
    let list = getRealResourceList(resources);
    return cc.loader.load(list, option, loadCallback)
}

var oldLoaderRelease = cc.loader.release
cc.loader.release = function (url) {
    // image加载失败时传入md5
  //  oldLoaderRelease.call(cc.loader, url)

    oldLoaderRelease.call(cc.loader, getRealResourceName(url))
}

//-------------label-----------------------------------
var oldLabelBMFontCreate = cc.LabelBMFont.create
cc.LabelBMFont.create = function () {
    var __VA_ARG = $slice(arguments, 0)
    var arg = sTable([2, __VA_ARG])
    getRealArgsByIndex(arg, 3)
    // WARN: maybe multi result
    return oldLabelBMFontCreate(...unpack(arg))
}
var oldLabelBMFontSetFntFile = cc.LabelBMFont.prototype.setFntFile
cc.LabelBMFont.prototype.setFntFile = function () {
    var __VA_ARG = $slice(arguments, 0)
    var arg = sTable([2, __VA_ARG])
    getRealArgsByIndex(arg, 2)
    // WARN: maybe multi result
    return oldLabelBMFontSetFntFile.apply(this, unpack(arg))
}
// var oldLabelCreateWithBmFont = cc.Label.createWithBMFont
// cc.Label.createWithBMFont = function () {
//     var __VA_ARG = $slice(arguments, 0)
//     var arg = sTable([2, __VA_ARG])
//     getRealArgsByIndex(arg, 2)
//     // WARN: maybe multi result
//     return oldLabelCreateWithBmFont(...unpack(arg))
// }
var oldccuiTextCreate = ccui.TextBMFont.create
ccui.TextBMFont.create = function () {
    var __VA_ARG = $slice(arguments, 0)
    var arg = sTable([2, __VA_ARG])
    getRealArgsByIndex(arg, 3)
    // WARN: maybe multi result
    return oldccuiTextCreate(...unpack(arg))
}
var oldccuiTextSetFntFile = ccui.TextBMFont.prototype.setFntFile
ccui.TextBMFont.prototype.setFntFile = function () {
    var __VA_ARG = $slice(arguments, 0)
    var arg = sTable([2, __VA_ARG])
    getRealArgsByIndex(arg, 2)
    // WARN: maybe multi result
    return oldccuiTextSetFntFile.apply(this, unpack(arg))
}
// var oldCcuiLabelBMFontSetFntFile = ccui.LabelBMFont.setFntFile
// ccui.LabelBMFont.prototype.setFntFile = function () {
//     var __VA_ARG = $slice(arguments, 0)
//     var arg = sTable([2, __VA_ARG])
//     getRealArgsByIndex(arg, 2)
//     // WARN: maybe multi result
//     return oldCcuiLabelBMFontSetFntFile.apply(this, unpack(arg))
// }
var csLoaderCreateNode = cc.CSLoader.createNode
cc.CSLoader.createNode = function () {
    var __VA_ARG = $slice(arguments, 0)
    var arg = sTable([2, __VA_ARG])
    getRealArgsByIndex(arg, 2)
    // WARN: maybe multi result
    return csLoaderCreateNode.apply(this, unpack(arg))
}
var csLoaderCreateTimeLine = cc.CSLoader.createTimeline
cc.CSLoader.createTimeline = function () {
    var __VA_ARG = $slice(arguments, 0)
    var arg = sTable([2, __VA_ARG])
    getRealArgsByIndex(arg, 2)
    // WARN: maybe multi result
    return csLoaderCreateTimeLine.apply(this, unpack(arg))
}
var ccSpriteBatchNode = cc.SpriteBatchNode.create
cc.SpriteBatchNode.create = function () {
    var __VA_ARG = $slice(arguments, 0)
    var arg = sTable([2, __VA_ARG])
    getRealArgsByIndex(arg, 2)
    // WARN: maybe multi result
    return ccSpriteBatchNode(...unpack(arg))
}
var ccSpriteCreate = cc.Sprite.create
cc.Sprite.create = function () {
    var __VA_ARG = $slice(arguments, 0)
    var arg = sTable([2, __VA_ARG])
    getRealArgsByIndex(arg, 2)
    // WARN: maybe multi result
    return ccSpriteCreate(...unpack(arg))
}
var ccuiScale9SpriteCreate = ccui.Scale9Sprite.create
ccui.Scale9Sprite.create = function () {
    var __VA_ARG = $slice(arguments, 0)
    var arg = sTable([2, __VA_ARG])
    getRealArgsByIndex(arg, 2)
    // WARN: maybe multi result
    return ccuiScale9SpriteCreate(...unpack(arg))
}
var frameCache = cc.spriteFrameCache
var ccSpriteFrameCacheAddSprite = frameCache.addSpriteFrames
frameCache.addSpriteFrames = function () {
    var __VA_ARG = $slice(arguments, 0)
    var arg = sTable([2, __VA_ARG])
    getRealArgsByIndex(arg, 2)
    getRealArgsByIndex(arg, 3)
    // WARN: maybe multi result
    return ccSpriteFrameCacheAddSprite.apply(frameCache, unpack(arg))
}
var ccSpriteFrameCacheRemoveFromFile = frameCache.removeSpriteFramesFromFile
frameCache.removeSpriteFramesFromFile = function () {
    var __VA_ARG = $slice(arguments, 0)
    var arg = sTable([2, __VA_ARG])
    getRealArgsByIndex(arg, 2)
    // WARN: maybe multi result
    return ccSpriteFrameCacheRemoveFromFile.apply(frameCache, unpack(arg))
}
var textureCache = cc.Director.getInstance().getTextureCache()
var textureCacheRemoveTextureForKey = textureCache.removeTextureForKey
textureCache.removeTextureForKey = function () {
    var __VA_ARG = $slice(arguments, 0)
    var arg = sTable([2, __VA_ARG])
    getRealArgsByIndex(arg, 2)
    if (arg[2]) {
        arg[2] = cc.FileUtils.getInstance().fullPathForFilename(arg[2])
    }
    // WARN: maybe multi result
    return textureCacheRemoveTextureForKey.apply(textureCache, unpack(arg))
}
var textureCacheGetTextureForKey = textureCache.getTextureForKey
textureCache.getTextureForKey = function () {
    var __VA_ARG = $slice(arguments, 0)
    var arg = sTable([2, __VA_ARG])
    getRealArgsByIndex(arg, 2)
    if (arg[2]) {
        arg[2] = cc.FileUtils.getInstance().fullPathForFilename(arg[2])
    }
    // WARN: maybe multi result
    return textureCacheGetTextureForKey.apply(textureCache, unpack(arg))
}
cc.game.addEventListener(cc.game.EVENT_RENDERER_INITED, function () {
    var textureCacheAddImage = textureCache.addImage
    textureCache.addImage = function () {
        var __VA_ARG = $slice(arguments, 0)
        var arg = sTable([2, __VA_ARG])
        getRealArgsByIndex(arg, 2)
        // WARN: maybe multi result
        return textureCacheAddImage.apply(textureCache, unpack(arg))
    }
    var textureCacheAddImageAsync = textureCache.addImageAsync
    textureCache.addImageAsync = function () {
        var __VA_ARG = $slice(arguments, 0)
        var arg = sTable([2, __VA_ARG])
        getRealArgsByIndex(arg, 2)
        // WARN: maybe multi result
        return textureCacheAddImageAsync.apply(textureCache, unpack(arg))
    }
})

let oldCCEditBoxCreate = cc.EditBox.create
cc.EditBox.create = function (size, bg, num) {
    let sprite = ccui.Scale9Sprite.createWithSpriteFrameName(bg)
    return oldCCEditBoxCreate.call(this, size, sprite)
}